module.exports = __webpack_public_path__ + "static/img/hn-bio.44fb6bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/case/hn-bio.jpg
// module id = 6r4s
// module chunks = 1